import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ListBlogs } from '../common';
import { Header } from '../common';
import { getPathLanguage } from '../../../utils/params';
// import { isMobile } from '../../../utils/constants';
// import { Subtract } from '../../../assets/images/web-isn';
import { Breadcrumb } from '../common';
import { useTranslation } from 'react-i18next';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';

const BlogsComponent = () => {
  const pathLanguage = getPathLanguage(useLocation());
  const params = useParams();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const urlBlogs =
    params.category !== 'all-blogs' &&
    params.category !== 'news' &&
    params.category !== 'newly-launched-properties' &&
    params.category !== 'rental-living-tips' &&
    params.category !== 'living-in-vietnam';
  const { t } = useTranslation();


  if (params.category && urlBlogs) {
    window.location.href = pathLanguage + '/blogs/all-blogs?pageIndex=1';
  }
  return (
    <>
      <Breadcrumb />
      <div
        className="section-block background-gray section-page-content"
      >
        <div className="container">
          <div className="header-details">
            {params.category ? (
              // isMobile ? (
              //   ''
              // ) : (
              <>
                <span className="title-blog blog-categories-margin-top">{t('blogs.categories')}</span>
                <div className="lower-border-category"></div>
                {/* <div id="blog-position-scroll"></div> */}
                <Header showLoader={showLoader} hideLoader={hideLoader} />
              </>
            )
              : (
                <>
                  <Header showLoader={showLoader} hideLoader={hideLoader} />
                </>
              )}

            <ListBlogs showLoader={showLoader} hideLoader={hideLoader} />
          </div>
        </div>
      </div>
      {loader}
    </>
  );
};

export default BlogsComponent;
